// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state/preferences';

const updateIsSaved = (state, action) => action.data;

export default (state = getDefaultState().isSaved, action) => {

    const actionTypes = {
        [actions.UPDATE_USER_PREFERENCES_IS_SAVED]: updateIsSaved
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/user/shared/reducers/update-is-saved.js